import type { Page, ShipFollowCustomPagingParams, ShipFollowCustomVo } from "@zhihaoscm/entity";
import { BaseService } from "./baseService";
import httpRequest from "./index";

// 船务信息服务费
export class ShipFollowCustomService extends BaseService<ShipFollowCustomVo, unknown, unknown, unknown> {
    // 关注列表
    public override async paging(params: ShipFollowCustomPagingParams): Promise<Page<ShipFollowCustomVo>> {
        const data = await this.service.get(`${this.path}/custom-paging`, { params });
        return data.data;
    }

    // 移除关注
    public async removeAttention(id: number | string) {
        return await this.service.delete(`${this.path}/${id}`);
    }

    // 关注 - 取消船舶
    public async follow(id: number | string) {
        return await this.service.post(`${this.path}/follow/${id}`);
    }
}

export const shipFollowCustomService = new ShipFollowCustomService("/ship-follow-custom", httpRequest);
